import styled from 'styled-components';
import { Table } from 'antd';

export const StyledTable = styled(Table)`
  .gm-ant-table {
    border-radius: 0;
  }

  .gm-ant-table-thead > tr:first-child > th {
    border-right: 2px solid #d9d9d9 !important;
    border-bottom: 1px solid #d9d9d9 !important;
    background-color: #fafafa !important;
    font-weight: bold !important;
    padding: 8px 12px !important;

    &:last-child {
      border-right: none !important;
    }
  }

  .gm-ant-table-thead > tr:first-child > th > div {
    display: flex;
    align-items: center;
    gap: 8px;
  }
` as typeof Table;

export const HeaderText = styled.span`
  color: rgb(0 0 0 / 85%);
  font-size: 14px;
`;

export const GrayHeaderText = styled(HeaderText)`
  color: rgb(0 0 0 / 45%);
`;

export const Control = styled.div`
  display: flex;
  align-items: center;
`;

export const DimensionValueContainer = styled.div`
  overflow-wrap: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    padding-right: 32px;
  }

  > button {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  &:not(:hover) > button {
    display: none;
  }
`;

export const DimensionValue = styled.span`
  cursor: pointer;
  color: #1890ff;
`;
